﻿<template>

  <aside class="cart-summary cart-side">

    <transition name="fade">
      <div v-if="displayPopup" class="cart-modal" role="dialog" aria-modal="true" aria-labelledby="cart-modal-title" @click.self="displayPopup = false">
        <div class="cart-modal-box">
          <div v-if="get_popup_image()" class="cart-modal-media">
            <img :src="get_popup_image()" alt="Image of available add-on" />
          </div>
          <div class="cart-modal-body">
            <button type="button" class="cart-modal-close" aria-label="Close" @click="displayPopup = false">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
            <h3 id="cart-modal-title">{{get_popup_text()}}</h3>
            <p>Add-ons are popular experiences that complement and enhance your trip. They sell out fast, so the purchase of tickets after checkout cannot be guaranteed.</p>
            <div class="cart-modal-actions">
              <button type="button" class="button button-pink-book full" @click="show_addons()">Show add-ons for my trip</button>
              <button type="button" class="cart-modal-skip" @click="check_out()">Continue without add-ons</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="basket-summary cart-summary-card">
      <itinerary_breakdown display_open=true :compact="true"></itinerary_breakdown>
      <hr />
      <trip_summary :show_percentage="true"></trip_summary>
      <trip_summary_discount v-if="get_Decimal_Total() > 1"></trip_summary_discount>
      <hr v-if="get_Decimal_Total() > 1"/>
      <div v-if="get_Decimal_Total() < 0" class="summary-total section">
        <div class="row">
          <h6 class="title text-base text-heading font-bold">Total Price</h6>
          <p class="text-black balance text-2xl text-action font-bold mb-0">{{ get_Total() }}<span class="font-normal text-lg"> {{ " " +get_Currency() }}</span><small class="font-normal text-sm"> includes all taxes.</small></p>
        </div>
      </div>
      <div class="summary-action section">
        <div class="cart-agree" :class="{ hidden: !get_Decimal_Total() || isAgent_Login() == true }">
          <p>Check in closes 15 minutes before departure time. We are unable to hold the bus or refund for late arrivals.</p>
          <label class="pp-check">
            <input v-model="agreeCheckbox" type="checkbox" class="focus:ring-action text-action border-grey-light rounded">
            I understand and agree.
          </label>
        </div>
        <div class="row">
          <button v-if="get_Decimal_Total() > 0 && agreeCheckbox" type="button" class="button button-pink-book full cart-cta" :disabled="booking_now" @click="addons_Check()">
            <svg v-if="booking_now" class="ts-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            {{ checkout }}
          </button>
          <button v-if="get_Decimal_Total() < 1" type="button" class="button full cart-cta is-disabled" disabled>
            Cart empty
          </button>
          <button v-if="get_Decimal_Total() > 0 && !agreeCheckbox" type="button" class="button full cart-cta is-disabled" disabled>
            Tick the box above to continue
          </button>
        </div>
        <div class="row">
          <small class="cart-contact">{{get_Contact_Text()}}</small>
        </div>
      </div>
    </div>
  </aside>
</template>

<script lang="ts" src="./summary.ts"></script>